// The intro story (docs/DESIGN.md §9.1): five painted cards with captions, shown on first launch
// and replayable from settings. Captions are runtime text, so they stay crisp and translatable.
// Each card is shown whole over a blurred copy of itself, so narrow screens never crop the art.

const CARDS: readonly { src: string; text: string }[] = [
  { src: 'art/story/intro_01.webp', text: 'Every night, when the lights go out…' },
  { src: 'art/story/intro_02.webp', text: '…the toys wake up.' },
  { src: 'art/story/intro_03.webp', text: 'But tonight, something crept out of the Forgotten Box.' },
  { src: 'art/story/intro_04.webp', text: 'The Gloom makes toys grumpy, clawed and giant-angry.' },
  { src: 'art/story/intro_05.webp', text: 'Only one small knight can stop it. Rise, Sir Tuck!' },
];

/** Plays the intro; resolves when the player finishes or skips it. */
export function playIntro(): Promise<void> {
  // Start loading every card now, so tapping through never waits.
  for (const c of CARDS) { const img = new Image(); img.src = c.src; }
  return new Promise((resolve) => {
    let i = 0;
    const root = document.createElement('div');
    root.id = 'story';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-label', 'Tiny Legends story');
    root.innerHTML = `<div class="story-blur"></div><img class="story-img" alt="">
      <div class="story-caption"><p></p>
        <div class="story-nav"><span class="story-dots"></span><button class="story-next"></button></div></div>
      <button class="story-skip">Skip</button>`;
    document.body.appendChild(root);
    const img = root.querySelector('.story-img') as HTMLImageElement;
    const blur = root.querySelector('.story-blur') as HTMLElement;
    const text = root.querySelector('.story-caption p') as HTMLElement;
    const dots = root.querySelector('.story-dots') as HTMLElement;
    const next = root.querySelector('.story-next') as HTMLButtonElement;

    const show = () => {
      const c = CARDS[i]!;
      root.classList.remove('in');
      void root.offsetWidth; // restart the fade
      img.src = c.src;
      blur.style.backgroundImage = `url(${c.src})`;
      text.textContent = c.text;
      dots.innerHTML = CARDS.map((_, k) => `<i class="${k === i ? 'on' : ''}"></i>`).join('');
      next.textContent = i === CARDS.length - 1 ? "Let's go!" : 'Next';
      root.classList.add('in');
    };
    const finish = () => {
      window.removeEventListener('keydown', onKey);
      root.remove();
      resolve();
    };
    const advance = () => { if (i < CARDS.length - 1) { i++; show(); } else finish(); };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') finish();
      else if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') { e.preventDefault(); advance(); }
    };
    root.addEventListener('click', (e) => {
      if ((e.target as HTMLElement).closest('.story-skip')) finish();
      else advance(); // anywhere else (including Next) moves on
    });
    window.addEventListener('keydown', onKey);
    show();
    next.focus();
  });
}
